// extracted by mini-css-extract-plugin
export default {"brandPromo":"hF-z","carousel":"iF-z"};